<template>
  <section class="px-4 py-12 md:py-16">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.winWin.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">{{ t('landing.winWin.body') }}</p>

      <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="side in SIDES"
          :key="side"
          class="p-6 rounded-2xl bg-neutral-700 text-left flex flex-col gap-2"
        >
          <h3 class="mt-0 mb-0">{{ t(`landing.winWin.${side}.title`) }}</h3>
          <p class="text-neutral-300 mt-0 mb-0">{{ t(`landing.winWin.${side}.text`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const SIDES = ['you', 'us'] as const
</script>
